export default "__VITE_ASSET__0GcGmVQ7__"